import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';

// iOS doesn't fully support click on document
var documentClickEvent = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
var documentScrollEvent = 'scroll';
/**
 * Component renders a tooltip without a close button. Only way to interact by
 * the user is by hovering the area to trigger a tooltip. To close a tooltip
 * user can hover out the area that triggered a tooltip.
 */
var TooltipComponent = /** @class */ (function (_super) {
    __extends(TooltipComponent, _super);
    function TooltipComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = null;
        _this.scrollHandler = null;
        _this.isOpen = false;
        _this.bodyTooltip = null;
        return _this;
    }
    TooltipComponent.prototype.destroyed = function () {
        if (this.bodyTooltip) {
            this.hideBodyTooltip();
        }
    };
    TooltipComponent.prototype.onDocumentClick = function (event) {
        if (this.isEventInsideTooltip(event)) {
            return;
        }
        this.onControlledClose();
    };
    TooltipComponent.prototype.onDocumentScroll = function () {
        this.onControlledClose();
    };
    TooltipComponent.prototype.openTooltip = function () {
        if (this.controlled) {
            return;
        }
        this.isOpen = true;
    };
    TooltipComponent.prototype.closeTooltip = function () {
        var _this = this;
        if (this.controlled) {
            return;
        }
        if (this.bodyTooltip) {
            if (this.bodyCloseTimeout) {
                clearTimeout(this.bodyCloseTimeout);
            }
            this.bodyCloseTimeout = setTimeout(function () {
                _this.isOpen = false;
            }, 200);
        }
        else {
            this.isOpen = false;
        }
    };
    TooltipComponent.prototype.handleCloseButtonClick = function () {
        this.isOpen = false;
        this.$emit('on-close', true);
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    TooltipComponent.prototype.onControlledClose = function () { };
    TooltipComponent.prototype.changeIsOpen = function () {
        if (this.controlled) {
            this.isOpen = this.isControlledOpen;
            this.syncDocumentHandlers();
        }
    };
    TooltipComponent.prototype.syncBodyTooltip = function () {
        if (!this.appendToBody) {
            return;
        }
        if (this.isOpen) {
            this.createBodyTooltip();
            this.positionBodyTooltip();
            this.fillBodyTooltipContent();
            this.attachBodyTooltip();
        }
        else {
            this.hideBodyTooltip();
        }
    };
    TooltipComponent.prototype.createBodyTooltip = function () {
        this.bodyTooltip = document.createElement('magic-ui-tooltip');
        this.bodyTooltip.setAttribute('controlled', 'true');
        this.bodyTooltip.setAttribute('is-controlled-open', 'true');
        this.bodyTooltip.setAttribute('is-body-content', 'true');
        if (this.hasCloseButton) {
            this.bodyTooltip.setAttribute('has-close-button', 'true');
        }
        if (this.label) {
            this.bodyTooltip.setAttribute('label', this.label);
        }
        if (this.position) {
            this.bodyTooltip.setAttribute('position', this.position);
        }
        if (this.arrowPosition) {
            this.bodyTooltip.setAttribute('arrow-position', this.arrowPosition);
        }
        if (this.caretMarginTop) {
            this.bodyTooltip.setAttribute('caret-margin-top', this.caretMarginTop.toString());
        }
        this.bodyTooltip.style.position = 'absolute';
        this.bodyTooltip.style.zIndex = '4';
    };
    TooltipComponent.prototype.positionBodyTooltip = function () {
        var _this = this;
        var parent = this.getParent().parentElement;
        var rect = parent.getBoundingClientRect();
        var style = this.bodyTooltip.style;
        var top = rect.top + window.scrollY + this.marginTop;
        var left = rect.left + window.scrollX;
        if (this.position === 'bottom') {
            style.top = top + rect.height + "px";
            style.left = left + rect.width / 2 + "px";
        }
        else if (this.position === 'top') {
            style.top = top + "px";
            style.left = left + rect.width / 2 + "px";
        }
        else if (this.position === 'left') {
            var content_1 = this.getParentContent();
            setTimeout(function () {
                var tooltipWidth = content_1.getBoundingClientRect().width;
                var padding = _this.getContentPadding();
                style.top = top + rect.height / 2 + "px";
                style.left = left - tooltipWidth - rect.width - padding + "px";
            });
        }
        else {
            if (this.arrowPosition === 'side') {
                style.top = top + 15 + "px";
                style.left = left + rect.width + "px";
            }
            else {
                style.top = top + rect.height / 2 + "px";
                style.left = left + rect.width + "px";
            }
        }
    };
    TooltipComponent.prototype.fillBodyTooltipContent = function () {
        this.bodyTooltip.appendChild(this.getParentContent());
    };
    TooltipComponent.prototype.getParentContent = function () {
        var parent = this.getParent();
        return parent.querySelector('[slot="content"]');
    };
    TooltipComponent.prototype.getContentPadding = function () {
        var content2 = this.$refs.content;
        var padding = getComputedStyle(content2).getPropertyValue('padding-left');
        return parseInt(padding, 10) * 2;
    };
    TooltipComponent.prototype.attachBodyTooltip = function () {
        var _this = this;
        document.body.querySelector('.app').appendChild(this.bodyTooltip);
        this.bodyTooltip.addEventListener('mouseenter', function () {
            if (_this.bodyCloseTimeout) {
                clearTimeout(_this.bodyCloseTimeout);
                _this.bodyCloseTimeout = undefined;
            }
        });
        this.bodyTooltip.addEventListener('mouseleave', function () {
            _this.isOpen = false;
        });
    };
    TooltipComponent.prototype.getParent = function () {
        // @ts-ignore
        return this.$el.parentNode.host;
    };
    TooltipComponent.prototype.hideBodyTooltip = function () {
        if (!this.bodyTooltip) {
            return;
        }
        var parent = this.getParent();
        var content = this.bodyTooltip.childNodes[0];
        if (content) {
            parent.append(content);
        }
        // `fillBodyTooltipContent` changes the parent element of "content"
        // before we remove the `bodyTooltip`, we restore the parent of "content"
        // so it's not lost from the DOM once we remove `bodyTooltip`
        this.bodyTooltip.remove();
    };
    TooltipComponent.prototype.syncDocumentHandlers = function () {
        if (this.isBodyContent) {
            return;
        }
        if (this.isOpen) {
            this.addClickHandler();
            this.addScrollHandler();
        }
        else {
            this.removeClickHandler();
            this.removeScrollHandler();
        }
    };
    TooltipComponent.prototype.addClickHandler = function () {
        this.clickHandler = this.onDocumentClick.bind(this);
        document.addEventListener(documentClickEvent, this.clickHandler);
    };
    TooltipComponent.prototype.addScrollHandler = function () {
        this.scrollHandler = this.onDocumentScroll.bind(this);
        document.addEventListener(documentScrollEvent, this.scrollHandler);
    };
    TooltipComponent.prototype.removeClickHandler = function () {
        if (this.clickHandler) {
            document.removeEventListener(documentClickEvent, this.clickHandler);
            this.clickHandler = null;
        }
    };
    TooltipComponent.prototype.removeScrollHandler = function () {
        if (this.scrollHandler) {
            document.removeEventListener(documentScrollEvent, this.scrollHandler);
            this.scrollHandler = null;
        }
    };
    TooltipComponent.prototype.isEventInsideTooltip = function (event) {
        var _this = this;
        var targets = event.composedPath
            ? event.composedPath()
            : [event.target];
        var tooltipTarget = this.getTooltipTarget();
        return targets.some(function (target) { return target === _this.bodyTooltip || target === tooltipTarget; });
    };
    TooltipComponent.prototype.getTooltipTarget = function () {
        return this.controlled ? this.getParent().parentElement : this.$el;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "label", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "controlled", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "isControlledOpen", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "position", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "arrowPosition", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "hasCloseButton", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "appendToBody", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "isBodyContent", void 0);
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], TooltipComponent.prototype, "marginTop", void 0);
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], TooltipComponent.prototype, "caretMarginTop", void 0);
    __decorate([
        Emit('controlled-close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipComponent.prototype, "onControlledClose", null);
    __decorate([
        Watch('isControlledOpen', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipComponent.prototype, "changeIsOpen", null);
    __decorate([
        Watch('isOpen'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipComponent.prototype, "syncBodyTooltip", null);
    TooltipComponent = __decorate([
        Component({
            name: 'ui-tooltip',
            inheritAttrs: false,
        })
    ], TooltipComponent);
    return TooltipComponent;
}(Mixins(MagicConfigMixin)));

export default TooltipComponent;
